var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPacienteYCalmado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1359,
    cy: 60.1652,
    r: 55.8215,
    fill: "#394F65",
    stroke: "#F1F6F9",
    strokeWidth: 7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.9299 53.0333C58.6292 51.7509 58.1633 50.2352 56.9973 49.5357C55.7147 48.8365 54.1992 49.3023 53.4998 50.4684C52.8003 51.7509 50.5853 51.8671 49.7688 50.4684C49.0694 49.186 47.5537 48.8365 46.2713 49.5357C44.9887 50.235 44.6392 51.7509 45.3384 53.0333C46.6208 55.3646 49.0694 56.7642 51.6332 56.7642C54.316 56.7642 56.6476 55.3646 57.9299 53.0333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9006 49.5357C72.6182 48.8365 71.1025 49.3023 70.403 50.4685C69.7037 51.7509 67.4885 51.8671 66.6721 50.4685C65.9728 49.186 64.4569 48.8365 63.1745 49.5357C61.8922 50.235 61.5425 51.7509 62.2417 53.0333C63.5243 55.3646 65.9726 56.7642 68.5365 56.7642C71.1012 56.7642 73.5489 55.3655 74.8313 53.0333C75.5324 51.8671 75.0666 50.2352 73.9006 49.5357Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0279 31C44.0569 31 31 44.0565 31 60.0279C31 75.9988 44.0565 89.0558 60.0279 89.0558C75.9989 89.0558 89.0558 75.9993 89.0558 60.0279C89.0558 44.0565 75.9993 31 60.0279 31ZM60.0279 83.3435C47.2039 83.3435 36.7123 72.8519 36.7123 60.0279C36.7123 47.2039 47.2039 36.7123 60.0279 36.7123C72.8519 36.7123 83.3435 47.2039 83.3435 60.0279C83.3435 72.851 72.8519 83.3435 60.0279 83.3435Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9367 64.224C68.538 63.4075 66.7889 63.8743 66.0897 65.273C64.9235 67.371 62.5921 68.7705 60.1444 68.7705C57.6959 68.7705 55.4817 67.4882 54.1992 65.273C53.3827 63.8743 51.6344 63.4075 50.3521 64.224C48.9534 65.0405 48.4866 66.7887 49.3031 68.0711C51.5183 72.0345 55.7151 74.3659 60.1444 74.3659C64.691 74.3659 68.8878 71.9173 71.103 68.0711C71.6852 66.7887 71.2191 65.0396 69.9367 64.224Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPacienteYCalmado);
export default __webpack_public_path__ + "static/media/PACIENTE_Y_CALMADO.450948bc1a6605805b8cbcd85bd74577.svg";
export { ForwardRef as ReactComponent };